export default __webpack_public_path__ + "static/media/brawl-stars.27db3f45.png";